module.exports = __webpack_public_path__ + "img/Clock_Icon_Hover.c178d9fb.svg";